const actionTypes = {
    SET_PRODUCT_ADD_SUCCESS: 'setProductAddSuccess',
}

export default actionTypes
